import React from "react";
import PlainRequestParameters from "./StatusAPI-JSON/PlainRequestParameters";
import FinalRequestParameters_Json from "./StatusAPI-JSON/FinalRequestParameters_Json";
import ResponseParametersStatusApi_Json from "./StatusAPI-JSON/ResponseParametersStatusApi_Json";
function StatusAPIPg() {
  return (
    <div class="idocs-content">
      <div class="container">
        <div class="row">
          <div class="col-md-8">
            <section id="idocs_content" class="mt-20 mb-20">
              <h1> STATUS API</h1>
              <hr />
            </section>

            <p>
              {" "}
              The Status API call can be used to check the status of a
              transaction / order.
            </p>

            <p>
            You can use this call if you have not received the status/information for a transaction request in real time.
            </p>

            <p>
              <span className="para-blod">Aes256 Crypto logic</span> encrypts and decrypts the JSON Request and Response parameters, respectively. 
            </p>

            <p>
              <span className="para-blod"> Iv- initialization vector </span> can be used along with the Encryption key for data encryption, and the value remains the constant mentioned in the Integration kit. 
            </p>

            <p className="para-blod">
            Please follow the below steps to process a refund at your end :
            </p>

            <p className="para-blod">Postman Collection </p>

            <p>
            We are providing the postman collection to check the transaction status more easily. The <b>Safexpay</b> team will share with you at the time of Integration. 
            </p>

            <p className="para-blod">
            Please find the credentials shared below to check the Status of the API flow:
            </p>

            <p className="para-blod">UAT Environment :</p>

            <table class="table table-bordered">
              <tbody className="table-bdy">
                <tr>
                  <td className="table-color">Live Status Post URL</td>
                  <td>
                    <a
                      href="https://uatcheckout.safexpay.ae/ms-transaction-core-1-0/transactionStatusRedirection/defaultTransactionStatus
"
                    >
                      {/* https://uatcheckout.safexpay.ae/ms-transaction-core-1-0/transactionStatusRedir
n/defaultTransactionStatu */}
                    </a>
                    <span>
                      https://uatcheckout.safexpay.ae/ms-transaction-core-1-0/transactionStatusRedirection/defaultTransactionStatus
                    </span>
                  </td>
                </tr>
                <tr>
                  <td className="table-color">UAT Merchant ID</td>
                  <td>202205240004</td>
                </tr>
                <tr>
                  <td className="table-color">UAT Encryption Key</td>
                  <td>j1C1iS53CGAIY3PDzJCTsMilKdjp14p7lTIWhc40xTI=</td>
                </tr>
                <tr>
                  <td className="table-color">Aggregator ID</td>
                  <td> paygate</td>
                </tr>
              </tbody>
            </table>

            <p className="para-blod">Production Environment :</p>

            <table class="table table-bordered">
              <tbody className="table-bdy">
                <tr>
                  <td className="table-color">Live Status Post URL</td>
                  <td>
                    {/* <a href="https://pg.safexpay.ae/ms-transaction-core-1-0/transactionStatusRedirection/defaultTransactionStatus">
                        https://pg.safexpay.ae/ms-transaction-core-1-0/transactionStatusRedirection/defaultTransactionStatus
                    </a> */}
                    <span>
                      https://pg.safexpay.ae/ms-transaction-core-1-0/transactionStatusRedirection/defaultTransactionStatus
                    </span>
                  </td>
                </tr>
                <tr>
                  <td className="table-color">Live Merchant ID</td>
                  <td>Shared by Safexpay</td>
                </tr>
                <tr>
                  <td className="table-color">Live Encryption Key</td>
                  <td>Shared by Safexpay</td>
                </tr>
                <tr>
                  <td className="table-color">Aggregator ID</td>
                  <td> paygate</td>
                </tr>
              </tbody>
            </table>

            <p className="para-blod">Request Parameters:</p>

            <p>
              Merchant must send the following parameters to <b>Safexpay</b> PG
              to check the Transaction status.
            </p>

            <table class="table table-bordered">
              <tbody className="table-bdy">
                <tr className="table-color">
                  <th>Parameter Name</th>
                  <th>Attribute Type</th>
                  <th> Mandatory</th>
                  <th>Description</th>
                </tr>
                <tr>
                  <td>ag_id</td>
                  <td>String</td>
                  <td>YES</td>
                  <td>Aggregator id is “paygate”</td>
                </tr>

                <tr>
                  <td>me_id</td>
                  <td>String</td>
                  <td>YES</td>
                  <td>MerchantID issued to you by Safexpay.</td>
                </tr>

                <tr>
                  <td>order_no</td>
                  <td>String</td>
                  <td>(Either order_no or ag_ref is required)</td>
                  <td>Your unique transactionOrder number.</td>
                </tr>

                <tr>
                  <td>ag_ref</td>
                  <td>String</td>
                  <td>(Either order_no or ag_ref is required)</td>
                  <td>
                    AG_ref id generated by the Safexpay during the transaction.
                  </td>
                </tr>
              </tbody>
            </table>

            <p className="para-blod">NOTE:</p>

            <p>
            "status": "Successful": This is the main status of the transaction (you should consider this as important). "res_code": "00000": This is the response code for the API; it says that the response sent successfully and there is no error in API. "res_message": "Successful," This is the response message for API, it says API sent response correctly. 
            </p>

            <p className="para-blod">LIST OF STATUS :</p>

            <p>
              <b>Pending</b> - When there is no response received from the Bank in real-time. 
            </p>

            <p>
              <b>Successful</b> - When a transaction is successful.{" "}
            </p>

            <p>
              <b>Failed</b> - When a transaction is failed. 
            </p>
            <p>
              <b>Refund</b> - When a transaction has been initiated for Refund. 
            </p>

            <p>
              {" "}
              <b>AuthSuccess</b>- Authorized transaction, when a transaction needs to be two-step verification. 
            </p>

            <p>
              <b>Step 1 :</b> when transaction initialized.
            </p>

            <p>
              <b>Step 2 : </b>The merchant needs to authorize the same from the Portal. 
            </p>

            <p>
              <b>Reversed</b> -When the Merchant reverses the auth/capture transaction. 
            </p>

            <p>
              <b>Voided</b> - When the Merchant wanted to cancel a transaction before settlement. 
            </p>
            <p>
              <b>Captured</b> - When the Merchant captured the transaction. 
            </p>

            <p>
            If you get Pending status, then we suggest you check after some time; it will get updated after getting the final response from the Bank’s end. 
            </p>
          </div>
          <div class="col-md-4">
            <PlainRequestParameters />

            <FinalRequestParameters_Json />

            <ResponseParametersStatusApi_Json />
          </div>
        </div>
      </div>
    </div>
  );
}
export default StatusAPIPg;
